<template>
  <div class="apply-msg msg-page" v-if="isShow">
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Dialog,
    Toast
  } from 'vant'
  import {
    QueryApplyProgress,
    checkin,
    GetReceiveInfo,
    newPhase,
    GetPatient,
    checkFace
  } from '../../api/api'
  import { getAgentApply } from '@/api/patient'

  import {
    mapState
  } from "vuex";
  import msgupload from "@/assets/msg_upload.png";
  import msgsuccess from "@/assets/msg_success.png";
  import msgerror from "@/assets/msg_error.png";
  Vue.use(Dialog)
  Vue.use(Toast)

  export default {
    data() {
      return {
        isShow: false,
        msgupload: msgupload,
        msgsuccess: msgsuccess,
        msgerror: msgerror,
        msg: {
          status: 'success', // 绿: success;黄: warn;蓝: info;红: error
          icon: '', // 成功: checked;警告: warning;中性信息: info;叉叉: clear
          png: msgsuccess, // png有值则无需前两项
          title: '审核通过',
          desc: ''
        },
        msgButtons: [
          {
            txt: '返回首页',
            type: 'info',
            onClick: this.toIndex.bind(this)
          }
        ],
        papid: '',
        name: '',
        idsn: '',
        showProgress: false,
        progress: [],
        // receiveInfo: null,
        showMedicine: false,
        showNextphase: false,
        submitisabled: false,
        nextTitle: '您当前阶段援助领药已完成，可点击开启下一阶段药品援助',
        userData: {},

        agentApply:null,//代领人对象

        // show_agent_apply:false,//代领人功能开关
      }
    },
    computed: {
      ...mapState(['userInfo','patientInfo']),
      // hasMedicine() {
      //   return this.receiveInfo && this.receiveInfo.drugs.length > 0 ? true : false
      // }
    },
    async created() {
      // console.log(this.userInfo)
      this.papid = this.userInfo.patient.papid
      await this.getData()
    },
    methods: {
      toIndex() {
        this.$wechat.closeWindow()
      },
      toTimeline() {
        this.$router.replace({
          name: 'Timeline'
        });
      },
      toUplad(val) {
        let rdata = {
          name: "Upload"
        }
        if (val) {
          if (val == 'follow') {
            rdata.query = {
              follow: true
            }
          } else if (val == 'review') {
            rdata.query = {
              category: '后续复核'
            }
          }
        }
        this.$router.replace(rdata);
      },
      toUpladFollow() {
        this.$router.replace({
          name: "Upload",
          query: {
            follow: true,
          }
        });
      },
      toUpladFuhe() {
        this.$router.replace({
          name: "Appointment",
          query: {
            category: '后续复核'
          }
        });
      },
      splitDate(date, local) {
        let arr = date.trim().split(/\s+/)
        if (local == 'before') {
          return arr[0]
        }
        if (local == 'after') {
          return arr[1]
        }
      },
      async getData() {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        // let {
        //   data
        // } = await checkin();
        // let userInfo = this.$store.getters.getUserInfo;
        // userInfo.patient = data
        // this.$store.commit("setUserInfo", userInfo);

         // this.userData = data
        // let patientRes= await GetPatient({papid: data.papid})
        const {
          patient,
          phase,
          predict,
          family,
          frontStatus,
          hospital,
          doctor,
          drugstore,
          mode_name,
          need_face_ocr,
          next_phase,
          prescription_unlock,
          receive_time_unlock,
          can_reapply
        } = this.patientInfo;
        console.log(this.patientInfo,'this.patientInfo');
        let query = await QueryApplyProgress({
          papid: this.papid
        })
        console.log("patient,phase",patient,phase)
        this.progress = query.data.progress
        // let re_info = await GetReceiveInfo({
        //   papid: this.papid
        // })
        // this.receiveInfo = re_info.data
        // console.log("receiveInfo",re_info.data)

        //患者申请和患者领药的人脸识别审核状态
        let faceResult=''
        let sendData={type:'患者申请'}
        if(predict) sendData={ type: '患者领药',predict_id:predict.id}
        await checkFace(sendData).then(res => {
          if (res.data) {
            faceResult = res.data.face
          }
        })
        if(predict&&predict.show_agent_apply){
          // this.show_agent_apply=true;//打开代领人功能
          console.log("打开代领药人功能")
          await getAgentApply({papid: this.papid}).then(res => {
            if (res.data) {
              this.agentApply = res.data
              console.log("代领人对象",this.agentApply)
            }
          })
        }
        //预测单解锁的人脸识别审核状态
        let faceResultUnlock=''
        if(predict){
          await checkFace({ type: '预测单解锁',predict_id:predict.id}).then(res => {
            if (res.data) {
              faceResultUnlock = res.data.face
            }
          })
        }


        if (patient.status == "初始") {
          if (patient.statusing == '申请中' || patient.statusing == '') {
            //未提交材料↓
            this.$router.replace({ name: "Upload" });
          } else if (patient.statusing == "待初审") {
            //等待初审↓
            this.toTimeline()
          } else if (patient.statusing == '初审驳回') {
            //初审驳回↓
            this.$router.replace({ name: "Upload" });
          }else if (patient.statusing == '预约申请通过') {
            //预约申请通过-进入纸质邮寄
            console.log("预约申请通过-进入纸质邮寄","patient.statusing",patient.statusing)
            this.$router.replace({ name: "MailPaperMaterials" });
          }else{
            console.log("患者状态:初始-",patient.statusing)
            this.$router.replace({ name: "Upload" });
          }
        } 
        //初审通过
        if (patient.status == "未入组") {
          
          if (phase.status != '审核通过') {
            //邮寄材料未通过
            this.$router.replace({ name: "MailPaperMaterials"});
          } else {
            //邮寄材料通过
            this.toTimeline()
          }
        } else if (patient.status == "在组") {
          //有预测单并且已领药-开启下一阶段
          if (predict && predict.is_received == 1) {
            this.$router.replace({
              name: "ChooseTime"
            });
            Toast.clear();
            return
          }
          if(predict){
            //锁定解锁
            //超出处方日期
            if(prescription_unlock){
              if(prescription_unlock.status!="通过"){
                this.$router.replace({name: "Upload"});
                Toast.clear();
                return
              }
              // else if(prescription_unlock.status=="通过"){
              //   if(predict_unlock.type=="超出计划领药日期"){
              //     if((faceResultUnlock &&faceResultUnlock.status=="审核通过")||predict.is_recognition==1){
              //       //人脸识别通过
              //     }else{//人脸识别未通过
              //       this.$router.replace({name: "Liveness",query: {category: '预测单解锁',predict_id:predict.id}})
              //       Toast.clear();
              //       return
              //     }
              //   }
              // }
            }
            //超出计划领药日期
            if(receive_time_unlock){
              if(receive_time_unlock.status!="通过"){
                this.toTimeline()
                Toast.clear();
                return
              }else if(receive_time_unlock.status=="通过"){
                if((faceResultUnlock &&faceResultUnlock.status=="审核通过")||predict.is_recognition==1){
                  //人脸识别通过
                }else if(need_face_ocr){//人脸识别未通过
                  this.$router.replace({name: "Liveness",query: {category: '预测单解锁',predict_id:predict.id}})
                  Toast.clear();
                  return
                }
              }
            }
          }

          if (patient.receive_phase == 1) {
            if (phase.file_review_status == '核对通过') {
              if (!predict) {
                this.toTimeline()
                // alert("没有领药信息")
              }else{
                if(need_face_ocr&&(predict.is_recognition==0&&faceResult.status!="审核通过")){//需要人脸识别
                  this.$router.replace({name: "Liveness",query: {category: '患者领药',predict_id:predict.id}})
                }else if(next_phase){//可以开启下一阶段
                  this.$router.replace({name: "ChooseTime"})
                }else if((faceResult &&faceResult.status=="审核通过")||predict.is_recognition==1){//人脸识别通过
                  //人脸识别后,领药和开启下一阶段前
                  // if(this.show_agent_apply){
                    if(predict && predict.name=='' && (this.agentApply&&this.agentApply.status=="初始")){//删除领药记录predict.name置空,this.agentApply.status设为初始
                      this.$router.replace({name: "AgentReceiving"})
                    }else if(this.agentApply&&this.agentApply.status=="审核通过"){
                      this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                    }else if(predict&&predict.name=='本人'){//已经选择了本人领药
                      this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                    }else if(this.agentApply&&this.agentApply.status!="撤销申请"){
                      this.$router.push({name:'AgentUpload'})
                    }else{
                      this.$router.replace({name: "AgentReceiving"})
                    }
                  // }else{
                  //   this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                  // }
                }else{
                  this.toTimeline()
                }
              }
            } else {
              if (phase.review_item_status == 1) {//上传全部材料
                if (phase.file_review_status == '核对未通过') {
                  this.$router.replace({
                    name: "Appointment",
                    query: {
                      category: '后续复核'
                    }
                  });
                } else if(phase.file_review_status == '等待核对'){
                  this.toTimeline()
                }else{
                  //phase.file_review_status为空
                  console.log("未知的phase.file_review_status:",phase.file_review_status)
                  this.$router.replace({
                    name: "Appointment",
                    query: {
                      category: '后续复核'
                    }
                  });
                }
              } else {//未上传全部材料
                this.$router.replace({
                  name: "Appointment",
                  query: {
                    category: '后续复核'
                  }
                });
              }
            }
          }
          if (patient.receive_phase >= 2) {
            if (phase.follow_up_status == "后续初审通过") {
              if (phase.file_review_status == '核对通过') {
                if (!predict) {
                  this.toTimeline()
                  // alert("没有领药信息")
                }else{
                  if(need_face_ocr&&(predict.is_recognition==0&&faceResult.status!="审核通过")){//需要人脸识别
                    this.$router.replace({name: "Liveness",query: {category: '患者领药',predict_id:predict.id}})
                  }else if(next_phase){//可以开启下一阶段
                    this.$router.replace({name: "ChooseTime"})
                  }else if((faceResult &&faceResult.status=="审核通过")||predict.is_recognition==1){//人脸识别通过
                  //人脸识别后,领药和开启下一阶段前
                  // if(this.show_agent_apply){
                    if(predict && predict.name=='' && (this.agentApply&&this.agentApply.status=="初始")){//删除领药记录predict.name置空,this.agentApply.status设为初始
                      this.$router.replace({name: "AgentReceiving"})
                    }else if(this.agentApply&&this.agentApply.status=="审核通过"){
                      this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                    }else if(predict&&predict.name=='本人'){//已经选择了本人领药
                      this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                    }else if(this.agentApply&&this.agentApply.status!="撤销申请"){
                      this.$router.push({name:'AgentUpload'})
                    }else{
                      this.$router.replace({name: "AgentReceiving"})
                    }
                  // }else{
                  //   this.$router.replace({name: "DrugInfo",query: {category: '后续复核'}})
                  // }
                  

                  }else{
                    this.toTimeline()
                  }
                }
              } else {//核对没通过
                if (phase.status == '审核通过') {//复审通过
                  if (phase.review_item_status == 1) {//上传全部材料
                    if (phase.file_review_status == '核对未通过') {
                      this.$router.replace({
                        name: "Appointment",
                        query: {
                          category: '后续复核'
                        }
                      });
                    } else if(phase.file_review_status == '等待核对'){
                      this.toTimeline()
                    }else{
                      //phase.file_review_status为空
                      console.log("未知的phase.file_review_status:",phase.file_review_status)
                      this.$router.replace({
                        name: "Appointment",
                        query: {
                          category: '后续复核'
                        }
                      });
                    }
                  } else {//还没上传材料过
                    this.$router.replace({
                      name: "Appointment",
                      query: {
                        category: '后续复核'
                      }
                    });
                  }
                } else {//复审未通过
                  this.$router.replace({ name: "MailPaperMaterials"});
                }
              }
              //后续初审没通过
            } else if (patient.follow_up_status == '') {
              this.$router.replace({ name: "Upload",query: {category:'阶段审核'}});
            }else if (patient.follow_up_status == '待初审') {
              this.toTimeline()
            } else if (patient.follow_up_status == '后续初审驳回') {
              this.$router.replace({name: "Upload",query: {category:'阶段审核'}})
            } else if (patient.follow_up_status == '预约申请通过') {
              //TODO:验证后续初审的页面跳转
              this.$router.replace({name: "MailPaperMaterials"})
            }else{
              console.log("后续初审没通过-",patient.follow_up_status)
              this.toTimeline()
            }
          }
        } else if (patient.status == "出组") {
            let out_reason = patient.out_reason
            if (patient.out_reason.includes('所有领药结束')) {
                out_reason = '您已领取完毕当前轮次援助药品，已出组。'
                if (can_reapply)out_reason = out_reason+'若需重新申请，请点击确认。'
            }
            if (can_reapply) {
                Dialog.confirm({
                    title: '您已出组',
                    message: `出组原因：${out_reason}`,
                    confirmButtonColor:'#1DC21C',
                }).then(() => {
                    this.$router.replace({
                        name: "Apply",
                        query:{
                            reapply:1
                        }
                    });
                }).catch((e)=>{
                    this.$router.replace({
                        name: "Timeline",
                    });
                })
            }else{
                Dialog.alert({
                    title: '您已出组',
                    message: `出组原因：${out_reason}`,
                    confirmButtonColor:'#1DC21C'
                }).then(() => {
                    this.$router.replace({
                        name: "Timeline",
                    });
                });
            }
            Toast.clear();
            return;
        }
        this.isShow = true;
        Toast.clear();
      }
    }

  }
</script>

<style lang="less">
  .apply-msg {
    background: #fff;
    position: relative;

    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1) 50%, rgba(247, 248, 255, 1) 100%);
    }

    &>* {
      position: relative;
      z-index: 10;
    }

    .msg-progress {
      margin: 20px 12% 30px;
    }

    .msg-medicine {
      margin: -20px 3% 16px;

      .van-cell-group__title {
        background: @theme-color;
        color: #fff;
        padding: 10px;
      }
    }

    .next-phase {
      margin: 16px 3%;

      .van-cell-group__title {
        background: @theme-color;
        color: #fff;
        padding: 10px;
      }
    }
  }
</style>